import {DateTimeUtils} from '../utils/date-time.utils';

export class ProjectListItemFilterModel {

    companyName?: string;
    projectName?: string;
    validityOfQuotationFromDate?: Date;
    validityOfQuotationToDate?: Date;
    status?: string[]; // ProjectStatusEnum


    public static fromJson(filterModel: any): ProjectListItemFilterModel {
        if (filterModel && filterModel.validityOfQuotationFromDate && typeof filterModel.validityOfQuotationFromDate === 'string') {
            filterModel.validityOfQuotationFromDate = DateTimeUtils.StringToDate(filterModel.validityOfQuotationFromDate);
        }
        if (filterModel && filterModel.validityOfQuotationToDate && typeof filterModel.validityOfQuotationToDate === 'string') {
            filterModel.validityOfQuotationToDate = DateTimeUtils.StringToDate(filterModel.validityOfQuotationToDate);
        }


        return filterModel  as ProjectListItemFilterModel;
    }

    public static stringify(filterModel: ProjectListItemFilterModel): string {
        const resultModel: any = {...filterModel};
        if (resultModel.validityOfQuotationFromDate && resultModel.validityOfQuotationFromDate instanceof Date) {
            resultModel.validityOfQuotationFromDate = DateTimeUtils.DateTimeToRestString(resultModel.validityOfQuotationFromDate);
        }
        if (resultModel.validityOfQuotationToDate && resultModel.validityOfQuotationToDate instanceof Date) {
            resultModel.validityOfQuotationToDate = DateTimeUtils.DateTimeToRestString(resultModel.validityOfQuotationToDate);
        }
        return JSON.stringify(resultModel);
    }
}
